import { setErrorMessage, setSuccessState } from "./reducer"

export const errorMessage = (dispatch,message = '') => {
    dispatch(setErrorMessage(message));
}

export const successMessage = (dispatch,message = '') => {
    dispatch(setSuccessState(message));
}